import React from "react";
import { Gallery as PhotoswipeGallery } from "react-photoswipe-gallery";
import styled from "styled-components";
import GalleryPicture from "~/components/PictureGallery/GalleryPicture";
import { Picture } from "~/components/PictureGallery/Picture";

const Wrapper = styled.div`
  width: 100%;
  padding-bottom: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Gallery = styled.div<{ numberOfImage: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(${({ numberOfImage }) => numberOfImage}, 100%);
  scroll-snap-type: x mandatory;
  overflow-x: scroll;
  --webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  scrollbar-width: none;
`;

const ImageContainer = styled.div`
  position: relative;
  scroll-snap-align: start;
`;

type SmallPictureGalleryProps = {
  gallery: Array<Picture>;
};

const SmallPictureGallery = ({ gallery }: SmallPictureGalleryProps) => {
  return (
    <PhotoswipeGallery
      options={{
        zoom: false,
        counter: false,
      }}
    >
      <Wrapper>
        <Gallery numberOfImage={gallery.length}>
          {gallery.map((picture, index) => (
            <ImageContainer key={index}>
              <GalleryPicture picture={picture} />
            </ImageContainer>
          ))}
        </Gallery>
      </Wrapper>
    </PhotoswipeGallery>
  );
};

export default SmallPictureGallery;
